export default "{\n    \"label\": \"Customer\"\n}\n"